import { render } from "./schedules.vue?vue&type=template&id=da589386"
import script from "./schedules.vue?vue&type=script&lang=js"
export * from "./schedules.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__